<template>
  <vs-row>
    <vs-col class="order-wrapper" vs-offset="3" vs-w="6" vs-type="flex">
      <vs-row>
        <vs-row vs-justify="center">
          <a href="https://beregszaszietterem.hu/etelrendeles">
            <img id="logo" :src="require('@/assets/images/logo/beregsz_logo.png')" alt="Logo">
          </a>
          <vs-divider></vs-divider>
        </vs-row>
        <vs-row v-if="orderData === 'ERROR'" vs-type="flex" vs-justify="center">
          <h3>Érvénytelen rendelési azonosító!</h3>
        </vs-row>
        <vs-row v-if="orderData !== 'ERROR' && orderData.OrderStatus" id="order-details">
          <vs-row vs-type="flex" vs-justify="center">
            <h3 class="bottomPad">Rendelés: #{{ $route.params.ref }}</h3>
          </vs-row>
          <vs-row vs-type="flex" vs-justify="center">
            <div v-if="orderData.OrderStatus === 'CANCEL'">
              <vs-row vs-justify="center"><h4 style="color: red;">Megszakított fizetés!</h4></vs-row>
              <vs-row vs-justify="center"><p>SimplePay tranzakció azonosító:
                <strong>{{ orderData.TransactionId }}</strong></p></vs-row>
              <vs-row vs-justify="center"><p>Ön megszakította a tranzakciót.</p></vs-row>
            </div>
            <div v-if="orderData.OrderStatus === 'TIMEOUT'">
              <vs-row vs-justify="center"><h4 style="color: red;">Időtúllépés</h4></vs-row>
              <vs-row vs-justify="center"><p>SimplePay tranzakció azonosító:
                <strong>{{ orderData.TransactionId }}</strong></p></vs-row>
              <vs-row vs-justify="center"><p>Ön túllépte a tranzakció elindításának lehetséges maximális idejét.</p>
              </vs-row>
            </div>
            <div v-if="orderData.OrderStatus === 'FAIL'">
              <vs-row vs-justify="center"><h4 style="color: red;">Sikertelen tranzakció!</h4></vs-row>
              <vs-row vs-justify="center"><p>SimplePay tranzakció azonosító:
                <strong>{{ orderData.TransactionId }}</strong></p></vs-row>
              <vs-row vs-justify="center"><p>Kérjük, ellenőrizze a tranzakció során megadott adatok helyességét.
                Amennyiben minden adatot helyesen adott meg, a visszautasítás
                okának kivizsgálása érdekében kérjük, szíveskedjen kapcsolatba lépni
                kártyakibocsátó bankjával.</p></vs-row>
            </div>

            <div v-if="orderData.OrderStatus === 'SUCCESS'">
              <vs-row vs-justify="center"><h4 style="color: green;">Sikeres tranzakció!</h4></vs-row>
              <vs-row vs-justify="center"><p>SimplePay tranzakció azonosító: <strong>{{
                  orderData.TransactionId
                }}</strong></p></vs-row>
              <vs-row vs-justify="center">
                <vs-row v-for="(item, index) in orderData.OrderedItems" :key="index" vs-justify="center">
                  <div>{{ item.ItemQty }} x {{ item.ItemName }} ({{ item.ItemPrice }} HUF)</div>
                  <vs-row v-for="(addon, addonIndex) in item.ItemAddons" :key="addonIndex">
                    <div>+ {{ addon.AddonName }} ({{ addon.AddonPrice }} HUF)</div>
                  </vs-row>
                </vs-row>
                <vs-row vs-justify="center"><strong>Összesen</strong>: {{ orderData.Total }} HUF</vs-row>
              </vs-row>
            </div>
            <vs-row vs-justify="center" v-if="orderData.OrderStatus !== 'SUCCESS'">
              <vs-button @click="resend()">Újraküld</vs-button>
            </vs-row>
          </vs-row>
        </vs-row>
        <vs-row v-if="orderData !== 'ERROR' && orderData.OrderStatus" style="margin-top: 15px;" vs-type="flex"
                vs-justify="center">
          <h4>Fizetés állapota:</h4>
        </vs-row>
        <vs-row v-if="orderData !== 'ERROR' && orderData.PaymentStatus" id="payment-details" vs-type="flex"
                vs-justify="center">
          <div v-if="orderData.PaymentStatus === 'TIMEOUT'">
            <vs-row vs-justify="center">
              <p>A fizetés időtúllépés miatt sikertelen.</p>
            </vs-row>
          </div>
          <div v-if="orderData.PaymentStatus === 'CANCELLED'">
            <vs-row vs-justify="center">
              <p>A fizetés megszakításra került.</p>
            </vs-row>
          </div>
          <div v-if="orderData.PaymentStatus === 'NOTAUTHORIZED'">
            <vs-row vs-justify="center">
              <p>A kártyához tartozó adatok hibásak.</p>
            </vs-row>
          </div>
          <div v-if="orderData.PaymentStatus === 'INPAYMENT'">
            <vs-row vs-justify="center">
              <p>A fizetés folyamatban van.</p>
            </vs-row>
          </div>
          <div v-if="orderData.PaymentStatus === 'INFRAUD'">
            <vs-row vs-justify="center">
              <p>A fizetési adatok vizsgálat alatt vannak.</p>
            </vs-row>
          </div>
          <div v-if="orderData.PaymentStatus === 'AUTHORIZED'">
            <vs-row vs-justify="center">
              <p>A kártyaadatok ellenőrzése sikeres.</p>
            </vs-row>
          </div>
          <div v-if="orderData.PaymentStatus === 'FRAUD'">
            <vs-row vs-justify="center">
              <p>A fizetés csalás gyanúja miatt megszakadt.</p>
            </vs-row>
          </div>
          <div v-if="orderData.PaymentStatus === 'FINISHED'">
            <vs-row vs-justify="center">
              <p>A fizetés teljesítésre került.</p>
            </vs-row>
          </div>
        </vs-row>
        <vs-row v-if="orderData.PaymentStatus === 'FINISHED'">
          <vs-row vs-type="flex" vs-justify="center">
            <h3>Sikeres rendelés, köszönjük a vásárlást!</h3>
          </vs-row>
          <vs-row vs-type="flex" vs-justify="center">
            <vs-icon icon="check" color="success" size="50px"></vs-icon>
          </vs-row>
          <vs-row vs-type="flex" vs-justify="center">
            <p>Ha ízlenek az ételeink, kedvelj minket facebookon!</p>
            <vs-row vs-type="flex" vs-justify="center">
              <iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fberegszaszi.etterem&tabs=timeline&width=0&height=0&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId" width="0" height="0" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
            </vs-row>
          </vs-row>
        </vs-row>
      </vs-row>
    </vs-col>
  </vs-row>
</template>

<script>

import {axiosInstance} from "@/main";

export default {
  name: "order_response",
  data() {
    return {
      orderData: '',
      paymentSuccess: false
    }
  },
  methods: {
    resend() {
      let self = this;
      axiosInstance
          .post('public/resendTransaction.php', {'orderRef': self.orderData.OrderRef})
          .then((resp) => {
            window.location.replace(resp.data.url);
          })
          .catch((err) => {
                if (err.response.status === 401)
                  self.$root.exterminatus();
                else {
                  self.$vs.notify({
                    title: 'Rendszerüzenet',
                    position: 'top-right',
                    text: err.response.data.message,
                    color: 'danger',
                    icon: 'error'
                  });
                }
              }
          );
    },
    checkForPaymentStatus(ref) {
      let self = this;
      self.$vs.loading({type: 'border', text: 'Fizetési állapot ellenőrzése...'});
      let interval = setInterval(() =>
          axiosInstance
              .post("public/queryOrderStatus.php", {'ref': ref})
              .then((resp) => {
                self.orderData = resp.data.orderItems;
                if (self.orderData.OrderStatus === 'SUCCESS' && (self.orderData.PaymentStatus !== 'INFRAUD' && self.orderData.PaymentStatus !== 'INPAYMENT')) {
                  clearInterval(interval);
                  self.paymentSuccess = true;
                }
                if(self.paymentSuccess) {
                  self.sendConfirmMail();
                  self.$vs.loading.close();
                }
              })
              .catch((err) => {
                self.$vs.notify({
                  title: 'Rendszerüzenet',
                  position: 'top-right',
                  text: err.response.data.message,
                  color: 'danger',
                  icon: 'error'
                });
              }), 5000);
    },
    sendConfirmMail() {
      let self = this;
      axiosInstance
          .post("public/sendMailConfirm.php", self.orderData)
          .catch((err) => {
            self.$vs.notify({
              title: 'Rendszerüzenet',
              position: 'top-right',
              text: err.response.data.message,
              color: 'danger',
              icon: 'error'
            });
          });
    }
  },
  created() {
    let self = this;
    const ref = self.$route.params.ref;

    axiosInstance
        .post("public/validateRef.php", {'ref': ref})
        .then((resp) => {
          if (!resp.data.orderItems.OrderedItems)
            self.orderData = 'ERROR';
          else {
            self.orderData = resp.data.orderItems;
            if (self.orderData.OrderStatus === 'SUCCESS' && (self.orderData.PaymentStatus === 'INFRAUD' || self.orderData.PaymentStatus === 'INPAYMENT'))
              self.checkForPaymentStatus(ref);
            else self.paymentSuccess = self.orderData.PaymentStatus === 'FINISHED';
          }
        })
        .catch((err) => {
          self.$vs.notify({
            title: 'Rendszerüzenet',
            position: 'top-right',
            text: err.response.data.message,
            color: 'danger',
            icon: 'error'
          });
        });
  }
}
</script>

<style scoped>
.bottomPad {
  padding-bottom: 35px;
}

.order-wrapper {
  background-color: rgba(255, 255, 255, 1);
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 80 40' width='80' height='40'%3E%3Cpath fill='%23eaddc5' fill-opacity='0.25' d='M0 40a19.96 19.96 0 0 1 5.9-14.11 20.17 20.17 0 0 1 19.44-5.2A20 20 0 0 1 20.2 40H0zM65.32.75A20.02 20.02 0 0 1 40.8 25.26 20.02 20.02 0 0 1 65.32.76zM.07 0h20.1l-.08.07A20.02 20.02 0 0 1 .75 5.25 20.08 20.08 0 0 1 .07 0zm1.94 40h2.53l4.26-4.24v-9.78A17.96 17.96 0 0 0 2 40zm5.38 0h9.8a17.98 17.98 0 0 0 6.67-16.42L7.4 40zm3.43-15.42v9.17l11.62-11.59c-3.97-.5-8.08.3-11.62 2.42zm32.86-.78A18 18 0 0 0 63.85 3.63L43.68 23.8zm7.2-19.17v9.15L62.43 2.22c-3.96-.5-8.05.3-11.57 2.4zm-3.49 2.72c-4.1 4.1-5.81 9.69-5.13 15.03l6.61-6.6V6.02c-.51.41-1 .85-1.48 1.33zM17.18 0H7.42L3.64 3.78A18 18 0 0 0 17.18 0zM2.08 0c-.01.8.04 1.58.14 2.37L4.59 0H2.07z'%3E%3C/path%3E%3C/svg%3E");
  background-attachment: fixed;
  box-shadow: 0 0 3px 0 #000;
  border-radius: 10px;
  margin-bottom: 55px;
  margin-top: 30px;
  padding: 15px 15px 25px;
}

</style>